import campaignConfig from '../../../../campaign-config/campaign.json';
import campaignVideo from '../../../../assets/videos/tutorend_video.mp4';
import headerBanner from '../../../../assets/images/banner.png';

export const globalColors = campaignConfig.global?.colors || {};
export const globalText = campaignConfig.global?.text || {};

const localOverviewAssets = {
	'src/assets/videos/tutorend_video.mp4': campaignVideo,
	'src/assets/images/banner.png': headerBanner,
};

export const tutorDetailsOverviewConfig =
	campaignConfig.tutor_details?.overview || {};

export const resolveTutorDetailsOverviewAsset = (asset) =>
	localOverviewAssets[asset] || asset;